import { XML_GetScale } from "./XML_GetScale";
import { XML_ConvertDPI } from "./XML_ConvertDPI";

export function XML_ScaleFont(fontSize, drawElement, layer) {
  var scale = XML_GetScale(drawElement, layer); //drawElement["scale"];
  if (scale == null) scale = 1.0;
  fontSize = Math.floor(fontSize * scale * XML_ConvertDPI(1));

  return fontSize;
}
